'use client';

import { c as _c } from "react/compiler-runtime";
import { formatWarsawLongDate } from '@algoacademy/shared/warsaw-calendar';
type ChangeBlockedNoticeProps = {
  reason: 'unpaidRenewal' | 'cancelled';
  /** Renewal date - the day a cancelled subscription ends. */
  renewsAt: Date;
};

/**
 * Two states where nothing can be filed, so nothing is offered to submit. The
 * refusal names the state and what has to happen first, because staff otherwise
 * retypes the e-mail expecting a different answer.
 */
export function ChangeBlockedNotice(t0) {
  const $ = _c(5);
  const {
    reason,
    renewsAt
  } = t0;
  let t1;
  if ($[0] !== reason || $[1] !== renewsAt) {
    t1 = reason === "unpaidRenewal" ? "Nieop\u0142acone odnowienie - nie mo\u017Cna zmieni\u0107 ustawie\u0144 mentoringu. Najpierw rozwi\u0105\u017C spraw\u0119 p\u0142atno\u015Bci, potem wr\xF3\u0107 tutaj." : `Subskrypcja została anulowana przez kupującego i kończy się ${formatWarsawLongDate(renewsAt)} - nie można zmienić jej ustawień. Po tej dacie wystaw nową ofertę i nowy link.`;
    $[0] = reason;
    $[1] = renewsAt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p role="alert" className="rounded-lg border border-borderError bg-backgroundSecondary p-4 text-contentRed text-sm">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}